import { useMemo } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle } from '@fortawesome/pro-solid-svg-icons'

import { Cursors } from '../../../../utils/constants'

/** @enum {string} */
export const Positions = Object.freeze({
  TOP: 'TOP',
  BOTTOM: 'BOTTOM',
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
  TOP_LEFT: 'TOP_LEFT',
  TOP_RIGHT: 'TOP_RIGHT',
  BOTTOM_LEFT: 'BOTTOM_LEFT',
  BOTTOM_RIGHT: 'BOTTOM_RIGHT'
})

const ResizeAnchor = ({ position, display, draggableProps, top, left, onResize }) => {
  const cursor = useMemo(() => {
    let cursor = Cursors.DEFAULT

    if ([Positions.TOP, Positions.BOTTOM].includes(position)) {
      cursor = Cursors.NORTH_SOUTH
    } else if ([Positions.LEFT, Positions.RIGHT].includes(position)) {
      cursor = Cursors.EAST_WEST
    } else if ([Positions.TOP_LEFT, Positions.BOTTOM_RIGHT].includes(position)) {
      cursor = Cursors.NORTH_WEST_SOUTH_EAST
    } else if ([Positions.TOP_RIGHT, Positions.BOTTOM_LEFT].includes(position)) {
      cursor = Cursors.NORTH_EAST_SOUTH_WEST
    }

    return cursor
  }, [position])

  const className = useMemo(() => {
    const hoverCursor = cursor !== Cursors.DEFAULT ? `hover-cu-${cursor}-res` : ''

    return `pos-abs ${hoverCursor}`
  }, [cursor])

  return (
    <>
      {display && (
        <div
          className={className}
          style={{ left, top }}
          onDrag={onResize(position)}
          {...draggableProps}
        >
          <FontAwesomeIcon icon={faCircle} />
        </div>
      )}
    </>
  )
}

export default ResizeAnchor
